export default __webpack_public_path__ + "static/media/module_type.4d881e12.svg";